import { Card, Grid, FormGroup, FormControlLabel, Checkbox, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import Select from "react-select";
import { PeriodList } from '../../../utils/PeriodList';
import { loadRepotingUsers } from '../../../redux/actions/lookups.action'
import { useDispatch, useSelector } from "react-redux";
import { axiosFetch } from "../../../utils/AxiosFetch";

function ExternalTrainingFilter(props) {
    const dispatch = useDispatch();
    const [userOption, setUserOption] = useState([]);
    const [title, setTitle] = useState("");
    const [period, setPeriod] = useState("");
    const [employee, setEmployee] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [reportingManagerOption, setReportingManagerOption] = useState([]);
    const [reportingManager, setReportingManager] = useState("");
    const [departmentOption, setDepartmentOption] = useState([]);
    const [teamOption, setTeamOption] = useState([]);
    const [dept, setDept] = useState("");
    const [team,setTeam] = useState("");


    let LUusersList = useSelector((state) => state.loadReportingUsers_Reducer.reportingUsers);

    useEffect(() => {
        if (LUusersList.length > 0) {
            setUserOption(LUusersList)
        }
    }, [LUusersList])

    useEffect(() => {
        fetchReportingManagerLookup();
        fetchDepartmentLookup();
    }, [])

    const handleTitleChange = (e) => {
        setTitle(e.target.value);
        if (props.from === "list") {
            props.onTitleFilter(e.target.value)
        }
        else {
            props.handleTitleChange(e.target.value);

        }
    }

    const handleClear = () => {
        if (props.from === "list") {
            props.onTitleFilter("");
            props.handleFilter(1);
        }
        else if(props.from === "all"){
            props.handleManager(null);
            props.handleDepartment(null);
            props.handleTeam(null);
            props.handleFilter(1);
        }
        else {
            props.handleTitleChange("");
            props.handleDateFilter("");
            props.handleyearFilter("");
            props.handleEmployee(0);
            props.handleFilter(1);            
        }
        setEmployee("")
        setTitle("");
        setPeriod("");
        setReportingManager("");
        setDept("");
        setTeam("");
    }


    const handlePeriod = (selected) => {
        setPeriod(selected)
        var value = selected.value;
        var yearValue = value.split("-")[0];
        var dateValue = value.split("-")[1];
        props.handleDateFilter(dateValue);
        props.handleyearFilter(yearValue);
    }
    const handleEmployee = (selected) => {
        setEmployee(selected);
        var value = selected.value;
        props.handleEmployee(parseInt(value))
    }
    const handleManager = (selected) => {
        setReportingManager(selected);
        var value = selected.value;
        props.handleManager(parseInt(value))
    }
    const handleDepartment = (selected) => {
        setTeam("");
        setDept(selected);
        var value = selected.value;
        props.handleDepartment(parseInt(value));
        fetchDepartmentTeamLookup(parseInt(value));
    }
    const handleTeam = (selected) => {
        setTeam(selected);
        var value = selected.value;
        props.handleTeam(parseInt(value));        
    }
    const handleInActiveChange = (event) => {
        if (event.target.checked) {
            props.handleInactive(false)
            props.handleFilter(false)
            setIsActive(false)
        }
        else {
            props.handleInactive(true)
            props.handleFilter(true)
            setIsActive(true)

        }
    }
    const fetchReportingManagerLookup = (req) => {
        axiosFetch({
          method: "POST",
          url: "/lookup/reportingmanagers",
          requestConfig: req
        })
          .then((res) => {
            if (res.status === 200) {
                setReportingManagerOption(res.data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      };
    const fetchDepartmentLookup = () => {
        axiosFetch({
            method: "GET",
            url: "/lookup/departments",
          })
            .then((res) => {
              if (res.status === 200) {
                setDepartmentOption(res.data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
    }
    const fetchDepartmentTeamLookup = (id) => {
        axiosFetch({
          method: "GET",
          url: `/lookup/department/teams/${id}`,
        })
          .then((res) => {
            if (res.status === 200) {
              setTeamOption(res.data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    
      };
    return (
        <div className="argus-filter-employee" style={{ marginRight: "0" }}>
            <ValidatorForm onSubmit={() => props.handleFilter()}>
                <h3 className="filter-heading">Filters</h3>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextValidator label="Search by Training Title" fullWidth value={title} onChange={handleTitleChange} />
                    </Grid>
                    {props.from !== "list" ?
                        <>{props.from !== "all" ?
                            <Grid item xs={12}>
                                <Select
                                    menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    placeholder={<div>Search by Employee</div>}
                                    options={userOption}
                                    value={employee}
                                    onChange={handleEmployee}
                                />
                            </Grid> : ""}

                            <Grid item xs={12}>
                                <Select
                                    menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    placeholder={<div>Select period</div>}
                                    options={PeriodList(3, "half")}
                                    value={period}
                                    onChange={handlePeriod}
                                />
                            </Grid></> : ""}
                    {props.from === "all"?
                    <>
                    <Grid item xs={12}>
                                <Select
                                    menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    placeholder={<div>Search by Creator</div>}
                                    options={reportingManagerOption}
                                    value={reportingManager}
                                    onChange={handleManager}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Select
                                    menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    placeholder={<div>Search by Department</div>}
                                    options={departmentOption}
                                    value={dept}
                                    onChange={handleDepartment}
                                />
                            </Grid>
                            {dept !==""?<Grid item xs={12}>
                                <Select
                                    menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    placeholder={<div>Search by Team</div>}
                                    options={teamOption}
                                    value={team}
                                    onChange={handleTeam}
                                />
                            </Grid>:""}
                    </>:""}
                    {/* <Grid item xs={3}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox onChange={handleInActiveChange}/>} label="Show Inactive Trainings" />
                        </FormGroup>
                    </Grid> */}
                    <Grid item xs={12} sx={{ textAlign: "center", margin: "8px 0", paddingBottom: "10px" }} className="grid-margins">
                        <Button className="theme-btn cancel-btn" sx={{ float: "none", marginRight: "10px" }} variant="contained"
                            onClick={() => handleClear()}
                        >
                            Clear
                        </Button>
                        <Button className="theme-btn" sx={{ float: "none" }} variant="contained" type="submit">
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </ValidatorForm>
        </div>
    )
}
export default ExternalTrainingFilter;